import { MessageDetails } from "@scrile/api-provider/dist/api/MessagesProvider";
const isMessageDefaultDetails = (details: MessageDetails | null): details is null => details === null;
export { isMessageDefaultDetails as typeGuard };
export { default } from "./MessageDefault";
